import React, { useEffect } from 'react';
import BidderItem from './BidderItem';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  makeStyles,
  IconButton,
} from '@material-ui/core';
import { useQueryClient } from 'react-query';
import { useSearchParams } from 'hooks/useSearchParams';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const ListOfBidders = ({ open, handleClose, id }) => {
  const classes = useStyles();
  const queryClient = useQueryClient();
  const [params, setParams] = useSearchParams();

  // const fetchOffers = async () => {
  //   const { data } = await axios.get(`/api/v1/admin/freight/order/${id}/bids`);
  //   return data;
  // };

  const data = queryClient.getQueryData(['offersList', params.get('orderId')]);

  return (
    <div>
      <Dialog fullWidth onClose={handleClose} open={open}>
        <DialogTitle>
          <div className="d-flex justify-content-between align-items-between">
            <span>لیست پیشنهاد ها</span>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        {data?.bids.length === 0 ? (
          <DialogContent className="text-center">
            <DialogContentText>پیشنهادی وجود ندارد.</DialogContentText>
            <Button
              fullWidth
              className="position-sticky"
              onClick={handleClose}
              color="secondary"
              variant={'contained'}
            >
              بستن
            </Button>
          </DialogContent>
        ) : (
          <>
            <List className={classes.root}>
              {data?.bids.map((item, i) => (
                <BidderItem key={i} bid={item} />
              ))}
            </List>
            <Button
              className="position-sticky"
              onClick={handleClose}
              color="secondary"
              variant={'contained'}
            >
              بستن
            </Button>
          </>
        )}
      </Dialog>
    </div>
  );
};

export default ListOfBidders;
